import React from 'react'
import PropTypes from 'prop-types'

import ThemeLogo from '../../../atoms/ThemeLogo'
import { useProtectedResource } from '../../../../hooks'

const Logo = ({
  settings
}) => {
  const { src, darkUrl, width, maxWidth, height, maxHeight, isPublicResource, ...rest } = settings
  const { loading, url } = useProtectedResource(src, isPublicResource)

  if (loading) {
    return null
  }

  return (
    <ThemeLogo
      url={url}
      darkUrl={darkUrl}
      style={{
        height,
        width,
        ...(rest || {})
      }}
    />
  )
}

Logo.propTypes = {
  settings: PropTypes.object.isRequired
}

export default Logo
